export default class AuthorizationError extends Error {
	public constructor() {
		super();
	}
}
